import { render, staticRenderFns } from "./AccessoryList.vue?vue&type=template&id=84b3d378&scoped=true&"
import script from "./AccessoryList.vue?vue&type=script&lang=js&"
export * from "./AccessoryList.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryList.vue?vue&type=style&index=0&id=84b3d378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b3d378",
  null
  
)

export default component.exports